const products = [
  {
    id: 1,
    name: "PPXOC Milkyway Dress In Black",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762056233/Screenshot_2025-11-02_093132_ofjxnk.png",
    tag: "NEW PRODUCT",
    status: "",
    link: "#",
  },
  {
    id: 2,
    name: "Blue Pattern PouchPPXOC Milkyway Dress In Yellow",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762059846/Screenshot_2025-11-02_103322_dgbmqx.png",
    tag: "OUT OF STOCK",
    status: "",
    link: "#",
  },
  {
    id: 3,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762059855/Screenshot_2025-11-02_103310_jrqrm9.png",
    status: "",
    link: "#",
  },
  {
    id: 4,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762060032/Screenshot_2025-11-02_103526_dctkqy.png",
    tag: "",
    status: "",
    link: "#",
  },
  {
    id: 5,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762060250/Screenshot_2025-11-02_103553_cmde0f.png",
    tag: "",
    status: "OUT OF STOCK",
    link: "#",
  },
  {
    id: 6,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762059846/Screenshot_2025-11-02_103322_dgbmqx.png",
    tag: "",
    status: "",
    link: "#",
  },
  {
    id: 7,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762060252/Screenshot_2025-11-02_103947_cd7qfn.png",
    tag: "NEW PRODUCT",
    status: "",
    link: "#",
  },
  {
    id: 8,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762060250/Screenshot_2025-11-02_103956_tsmn08.png",
    tag: "",
    status: "",
    link: "#",
  },
  {
    id: 9,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762060265/Screenshot_2025-11-02_104003_glhmvy.png",
    tag: "",
    status: "",
    link: "#",
  },
  {
    id: 10,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762061861/Screenshot_2025-11-02_110513_jhtaxs.png",
    tag: "NEW PRODUCT",
    status: "",
    link: "#",
  },
  {
    id: 11,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762061861/Screenshot_2025-11-02_110524_kzazll.png",
    tag: "",
    status: "",
    link: "#",
  },
  {
    id: 12,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762061861/Screenshot_2025-11-02_110535_frsutp.png",
    tag: "",
    status: "",
    link: "#",
  },
  {
    id: 13,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762059855/Screenshot_2025-11-02_103310_jrqrm9.png",
    tag: "",
    status: "",
    link: "#",
  },
  {
    id: 14,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762059846/Screenshot_2025-11-02_103322_dgbmqx.png",
    tag: "",
    status: "",
    link: "#",
  },
  {
    id: 15,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762060032/Screenshot_2025-11-02_103526_dctkqy.png",
    tag: "",
    status: "",
    link: "#",
  },
  {
    id: 16,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762060265/Screenshot_2025-11-02_104003_glhmvy.png",
    tag: "",
    status: "OUT OF STOCK",
    link: "#",
  },
  {
    id: 17,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762060250/Screenshot_2025-11-02_103553_cmde0f.png",
    tag: "",
    status: "",
    link: "#",
  },
  {
    id: 18,
    name: "PRODUCT NAME",
    image: "https://res.cloudinary.com/douyiqjdq/image/upload/v1762061861/Screenshot_2025-11-02_110535_frsutp.png",
    tag: "",
    status: "",
    link: "#",
  },
];

export default products;
